(function () {

    "use strict";

    angular
        .module('components')
        .component('hEmojiSelector', {
            controller: HEmojiSelectorComponent,
            controllerAs: '$ctrl',
            bindings: {
                onOpenDialog: '&',
                onEmojiSelected: '&'
            },
            templateUrl: '../hmodules/components/h-emojis/h-emoji-selector/h-emoji-selector.component.html'
        });

    HEmojiSelectorComponent.$inject = ['$scope'];

    function HEmojiSelectorComponent($scope) {

        var self = this;

        self.$onInit = function () {

        };

        var closeEmojisDialog = function () {
            self.showEmojisSelector = false;
            $(document).off("click.add-emoji");
        };

        self.openEmojiesDialog = function () {
            self.onOpenDialog();
            self.showEmojisSelector = true;
            setTimeout(function () {
                $(document).on("click.add-emoji", function (event) {
                    if ($(event.target).parents(".h-emoji-selector").length === 0) {
                        closeEmojisDialog();
                        $scope.$digest();
                    }
                });
            }, 1);
        };


        self.selectEmoji = function (emojiCode) {
            closeEmojisDialog();
            self.onEmojiSelected({emojiCode: emojiCode});
        };
    }
})();
